import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *班级平均分
 * @param classId
 * 
*/

export const classAvg = classId => Http.get(`${baseUrl}/statistics/${classId}/avg`)

/**
 *团队排行榜
 * @param classId
 * 
*/

export const teamRanking = classId => Http.get(`${baseUrl}/statistics/${classId}/team`)

/**
 *个人排行榜
 * @param classId
 * 
*/

export const personalRanking = classId => Http.get(`${baseUrl}/statistics/${classId}/user`)

/**
 *学生个人(团队)章节成绩
 * @param params
 * 
*/

export const chapterScore = params => Http.get(`${baseUrl}/statistics/${params.classId}/${params.type}/${params.id}/score`)

/**
 *知识考核班级统计
 * @param params
 * 
*/

export const zsStatistics = params => Http.get(`${baseUrl}/statistics/zs/${params.classId}`, { params })

/**
 *知识考核题型平均分
 * @param params
 * 
*/

export const typeAvg = params => Http.get(`${baseUrl}/statistics/zs/${params.classId}/questionTypeAvg`, { params })

/**
 *知识考核个人习题情况
 * @param params
 * 
*/

export const userQuestion = params => Http.get(`${baseUrl}/statistics/zs/${params.classId}/${params.userId}/question`, { params })

/**
 *知识考核个人成绩列表
 * @param params
 * 
*/

export const userScoreList = params => Http.get(`${baseUrl}/statistics/zs/${params.classId}/scoreAvg`, { params })

/**
 *知识考题目选项选择率
 * @param params
 * 
*/

export const userQuestionRate = params => Http.get(`${baseUrl}/statistics/zs/${params.classId}/question/${params.questionId}/rate`)

/**
 *知识考题目(正确right,错误error,未做notDone)学生
 * @param params
 * 
*/

export const userQuestionInfo = params => Http.get(`${baseUrl}/statistics/zs/${params.classId}/question/${params.questionId}/${params.type}`)

/**
 *态度考核个人成绩列表
 * @param params
 * 
*/

export const userTdScoreList = params => Http.get(`${baseUrl}/statistics/td`, { params })

/**
 *态度考核详情
 * @param params
 * 
*/

export const userTdDetail = params => Http.get(`${baseUrl}/statistics/td/info`, { params })

/**
 *技能考核个人成绩列表
 * @param params
 * 
*/

export const userJnScoreList = params => Http.get(`${baseUrl}/statistics/jn`, { params })

/**
 *素养考核个人成绩列表
 * @param params
 * 
*/

export const userSyScoreList = params => Http.get(`${baseUrl}/statistics/sy`, { params })

/**
 *最终成绩列表
 * @param classId
 * 
*/

export const finalScoreList = classId => Http.get(`${baseUrl}/statistics/class/end/score/${classId}/final`)

/**
 *期末成绩列表
 * @param classId
 * 
*/

export const userEndScoreList = classId => Http.get(`${baseUrl}/statistics/class/end/score/${classId}`)

/**
 *期末成绩模板导入
 * @param classId
 * @param params
 * 
*/

export const importTemplate = (classId, params) => Http.post(`${baseUrl}/statistics/class/end/score/${classId}/import`, params)

/**
 *删除期末成绩列表
 * @param classId
 * 
*/

export const delEndScoreList = classId => Http.delete(`${baseUrl}/statistics/class/end/score/${classId}`)

/**
 *教师考核成绩列表
 * @param classId
 * 
*/

export const userTeacherScoreList = classId => Http.get(`${baseUrl}/statistics/class/teacher/score/${classId}`)

/**
 *教师考核成绩模板导入
 * @param classId
 * @param params
 * 
*/

export const importTeacherScoreTemplate = (classId, params) => Http.post(`${baseUrl}/statistics/class/teacher/score/${classId}/import`, params)

/**
 *删除教师考核成绩列表
 * @param classId
 * 
*/

export const delTeacherScoreList = classId => Http.delete(`${baseUrl}/statistics/class/teacher/score/${classId}`)
